<div dir="ltr" class="container py-3">
  <div class="row m-0 border-bottom border-2 mb-3">
    <div class="col-3">
      <input [(ngModel)]="newSetting.Id" placeholder="unique setting key" />
    </div>
    <div class="col-7">
      <textarea rows="4" [(ngModel)]="newSetting._json" placeholder="setting JSON value"></textarea>
    </div>
    <div class="col-2">
      <button (click)="save(newSetting)" class="btn btn-blue">ایجاد</button>
    </div>
  </div>

  <h1>----- CONFIG -----</h1>
  <ng-container *ngFor="let config of configs">
    <div class="row m-0 border-bottom mb-2">
      <h4 class="col-3">{{config.Id}}</h4>
      <div class="col-7">
        <textarea rows="10" [(ngModel)]="config.Json"></textarea>
      </div>
      <div class="col-2">
        <button (click)="setConfig(config)" class="btn btn-white">ذخیره</button>
      </div>
    </div>
  </ng-container>

  <h2>Add Config</h2>
  <div class="row m-0 border-bottom mb-2">
    <div class="col-3">
      <input [(ngModel)]="newConfig.Id" placeholder="unique config key" />
    </div>
    <div class="col-7">
      <textarea rows="10" [(ngModel)]="newConfig.Json"></textarea>
    </div>
    <div class="col-2">
      <button (click)="setConfig(newConfig)" class="btn btn-white">ذخیره</button>
    </div>
  </div>

  <h1>----- SETTINGS -----</h1>
  <ng-container *ngFor="let setting of settings">
    <div class="row m-0 border-bottom mb-2">
      <h4 class="col-3">{{setting.Id}}</h4>
      <div class="col-7">
        <textarea rows="10" [(ngModel)]="setting._json"></textarea>
      </div>
      <div class="col-2">
        <button (click)="save(setting)" class="btn btn-white">ذخیره</button>
      </div>
    </div>
  </ng-container>
</div>